/**
 * 计算指定日期前后 30 天的日期
 * @param {string} dateStr - 日期字符串
 * @returns {Object} - 包含前后 30 天日期的对象
 */
export default function getDaysRange(str,admins) {
    console.log('计算时间了',str,admins)
    let isWithin30DaysBefore = null
    let isWithin30DaysAfter = null
    // 将字符串转换为 Date 对象
    const targetDate = new Date(str);

    // 计算往前 30 天的日期
    const thirtyDaysBefore = new Date(targetDate);
    thirtyDaysBefore.setDate(thirtyDaysBefore.getDate() - 30);

    // 计算往后 30 天的日期
    const thirtyDaysAfter = new Date(targetDate);
    thirtyDaysAfter.setDate(thirtyDaysAfter.getDate() + 30);

    // 获取当前日期
    const currentDate = new Date();
    // const currentDate = '2025-07-25 00:00:00';


    isWithin30DaysBefore = currentDate >= thirtyDaysBefore && currentDate <= targetDate;
    isWithin30DaysAfter = currentDate >= targetDate && currentDate <= thirtyDaysAfter;
    if (isWithin30DaysBefore) { //当前日期前 30 天内
        localStorage.setItem('jump',JSON.stringify({
            flag:false,
            timer:str,
            user:admins
        }))
    } else if (isWithin30DaysAfter) {//当前日期后30天内
        localStorage.setItem('jump',JSON.stringify({
            flag:true,
            timer:str,
            user:admins
        }))
    }else{
        localStorage.setItem('jump',JSON.stringify({
            flag:null,
            timer:str,
            user:admins
        }))
    }
}

